import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  useEffect(() => { document.title = 'Page not found — Haven Crest Health'; }, []);
  return (
    <main>
      <section className="section">
        <div className="wrap center">
          <div className="eyebrow">404</div>
          <h1 className="display">That page isn't in the inbox.</h1>
          <p className="lede">The address may be wrong, or the page moved. Here are the two places most people are looking for.</p>
          <div className="hero__ctas" style={{ justifyContent: 'center' }}>
            <Link to="/" className="btn btn--ink">Home</Link>
            <Link to="/contact" className="btn btn--ghost">Get an advocate, free</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
